import countryCodes from './countryCodes.json'

export const validatePhoneNumber = (phoneNumber: string, countryCode: string) => {
  // Remove spaces non numeric digits and remove 44 or 0 from start of number
  let cleanedNumber = phoneNumber.replace(/ /g, '').replace(/\D/g, '')
  if (cleanedNumber.slice(0, 2) === '44') cleanedNumber = cleanedNumber.substr(2, phoneNumber.length)
  if (cleanedNumber[0] === '0') cleanedNumber = cleanedNumber.substr(1, cleanedNumber.length - 1)

  // Parse phone number
  const parsedNumber = `${countryCode}${cleanedNumber}`
  const numberIsValid = parsedNumber.length > 8 && parsedNumber[0] === '+'
  return numberIsValid ? parsedNumber : ''
}

export const splitPhoneNumber = (phoneNumber: string) => {
  const codes = countryCodes.filter(c => c.dialCode).map(c => c.dialCode).sort((a, b) => b!.length - a!.length)

  let countryCode = ''
  for (const code of codes) {
    if (phoneNumber.indexOf(code!) === 0) {
      countryCode = code!
      break
    }
  }

  return [countryCode, phoneNumber.substring(countryCode.length)]
}